import { getRuntimeApiUrl } from './runtimeConfig';

export function resolveApiBaseUrl(
  runtimeApiUrl: string | undefined,
  buildApiUrl: string | undefined,
): string {
  const apiUrl = runtimeApiUrl?.trim() || buildApiUrl?.trim();
  return apiUrl ? `${apiUrl.replace(/\/+$/, '')}/api/v1` : '/api/v1';
}

export function getApiBaseUrl(): string {
  return resolveApiBaseUrl(getRuntimeApiUrl(), import.meta.env.VITE_API_URL);
}

export function resolveApiUrl(
  path: string,
  runtimeApiUrl: string | undefined,
  buildApiUrl: string | undefined,
): string {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${resolveApiBaseUrl(runtimeApiUrl, buildApiUrl)}${normalizedPath}`;
}

export function getApiUrl(path: string): string {
  return resolveApiUrl(path, getRuntimeApiUrl(), import.meta.env.VITE_API_URL);
}
